import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

const { PROCEDURE_SHARED_URI } = environment;
const { PROCEDURE_SECURITY_URI } = environment;
const { PROCEDURE_NOTIFICATIONS_URI } = environment;

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) {
  }


  getPais(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Pais/GetPais`);
  }

  getSexo(): Observable<any> {
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Sexo/GetSexo`);
  }

  getGenero(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Sexo/GetGenero`);
  }


  getOrientacion(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Sexo/GetOrientacion`);
  }


  getEtnia(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Etnia/GetEtnia`);
  }


  getEstadoCivil(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/EstadoCivil/GetEstadoCivil`);
  }


  getNivelEducativo(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/NivelEducativo/GetNivelEducativo`);
  }


  getTipoIdentificacion(): Observable<any>{
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/TipoIdentificacion/GetTipoIdentificacion`);
  }


  saveLegalPerson(data: any): Observable<any> {
    return this.http.post(`${PROCEDURE_SHARED_URI}/v2/Persona/AddPersonaJuridica`, data);
  }

  saveNaturalPerson(data: any): Observable<any> {
    return this.http.post(`${PROCEDURE_SHARED_URI}/v2/Persona/AddPersonaNatural`, data);
  }

  getInfoUserByIdDocument(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_SHARED_URI}/v2/Persona/GetInfoUserByIdDocument/${id}`);
  }

  getInfoUserByIdCodeVentanilla(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_SHARED_URI}/v2/Persona/GetInfoUserById/${id}`);
  }

  addPoliticaSeguridad(datosPersona: any): Observable<any> {
    return this.http.post(`${PROCEDURE_SHARED_URI}/v1/PoliticaSeguridad/AddPoliticaSeguridad`, datosPersona);
  }

  getPoliticaSeguridad(oidToken_usuario): Observable<any> {
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/PoliticaSeguridad/GetPoliticaSeguridad/${oidToken_usuario}`);
  }

  sendEmail(cuerpoEmail: any): Observable<any> {
    return this.http.post(`${PROCEDURE_NOTIFICATIONS_URI}/Email/SendMail`, cuerpoEmail);
  }

  getRoleByIdUser(id: any) : Observable<any> {
    return this.http.get(`${PROCEDURE_SECURITY_URI}/GetRoleByIdUser/${id}`);
  }

  getCodeVentanillaByIdUser(idToken) : Observable<any> {
    return this.http.get(`${PROCEDURE_SECURITY_URI}/GetCodeVentanillaByIdUser/${idToken}`);
  }

  addUserToSecurityAPI(data): Observable<any> {
    return this.http.post(`${PROCEDURE_SECURITY_URI}/AddUser`, data);
  }

  updateUser(data): Observable<any> {
    return this.http.put(`${PROCEDURE_SECURITY_URI}/UpdateUser`, data);
  }

  addUserRol(data): Observable<any> {
    return this.http.post(`${PROCEDURE_SECURITY_URI}/AddUserRole`, data);
  }
}
